export const SUBSCRIPTION_MANAGER_TABS = {
    main: "0",
    see_plans: "1",
    upgrade: "3",
    cancel: "4",
    confirmSubscription: "5",
};